import { QqActionType } from "../qq-action.type";
import { QqStateType } from "../qq-state.type";

export abstract class QqMessageProcessorBase {
  abstract process(action: QqActionType, state: QqStateType): QqStateType;
}
